const localHosts = ["localhost", "127.0.0.1", "0.0.0.0"];

export const isFinancialDashboardEnabled = () =>
  process.env.REACT_APP_ENABLE_FINANCIAL_DASHBOARD === "true";

export const isFinancialDashboardMenuEnabled = () =>
  process.env.REACT_APP_SHOW_FINANCIAL_DASHBOARD_MENU === "true";

export const isClientFinancialEnabled = () =>
  process.env.REACT_APP_ENABLE_CLIENT_FINANCIAL === "true";

const previewEmails = value => String(value || "")
  .split(",")
  .map(email => email.trim().toLowerCase())
  .filter(Boolean);

const hasPreviewEmail = (user, configuredEmails) => {
  const email = String(user?.email || "").trim().toLowerCase();
  return Boolean(email) && previewEmails(configuredEmails).includes(email);
};

export const isFinancialAdminPreviewUser = user =>
  user?.role === "ADMIN" && hasPreviewEmail(user, process.env.REACT_APP_FINANCIAL_ADMIN_PREVIEW_EMAILS);

export const isFinancialClientPreviewUser = user =>
  user?.role === "CLIENT" && hasPreviewEmail(user, process.env.REACT_APP_FINANCIAL_CLIENT_PREVIEW_EMAILS);

export const isLocalhost = () =>
  typeof window !== "undefined" && localHosts.includes(window.location.hostname);

export const isDocumentCadenceEnabled = () =>
  process.env.REACT_APP_ENABLE_DOCUMENT_CADENCE !== "false" || isLocalhost();

export const isXavierThemeV2Enabled = () => {
  const configuredValue = process.env.REACT_APP_ENABLE_XAVIER_THEME_V2;

  if (configuredValue === "true") {
    return true;
  }

  if (configuredValue === "false") {
    return false;
  }

  return isLocalhost();
};

export const isFinancialClientUser = user => user?.role === "CLIENT";

export const isFinancialNativeReviewEnabled = () =>
  process.env.REACT_APP_ENABLE_FINANCIAL_NATIVE_REVIEW === "true";
export const isFinancialNativeReviewWritesEnabled = () =>
  process.env.REACT_APP_ENABLE_FINANCIAL_REVIEW_WRITES === "true";
export const isFinancialEvidenceReferenceCheckEnabled = () =>
  process.env.REACT_APP_ENABLE_FINANCIAL_EVIDENCE_REFERENCE_CHECK === "true";

export const isFinancialOfficeApprovalEnabled = () =>
  process.env.REACT_APP_ENABLE_FINANCIAL_OFFICE_APPROVAL === "true";

export const isFinancialBillingConsultationEnabled = () => process.env.REACT_APP_ENABLE_FINANCIAL_BILLING_CONSULTATION === "true";
